
import { Options, Vue } from "vue-class-component";

import SideMenu from "../components/WorkBench/SideMenu.vue";

import {
  readRecordProject,
  readSimpleScriptList,
  readTaskRecord,
  readTaskStatus,
} from "@/store/task/getters";
import {
  dispatchGetSimpleScripts,
  dispatchGetTaskRecord,
  dispatchGetTaskRecordProject,
  dispatchGetTaskStatus,
  dispatchRunTask,
} from "@/store/task/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { store } from "@/store";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
} from "@/utils";
import {
  dispatchGetMyProjects,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import { readMyProjects, readProjectScenes } from "@/store/project/getters";
import {
  readRefreshControl,
  readTaskLogs,
  readUserProfile,
} from "@/store/main/getters";
import { commitSetRefreshControl } from "@/store/main/mutations";
import {
  readPerformances,
  readPerformanceTableFields,
} from "@/store/performance/getters";
import {
  dispatchGetPerformances,
  dispatchGetPerformanceTableFields,
} from "@/store/performance/actions";
import {
  dispatchGetTaskLogs,
  dispatchGetUserProfile,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";

@Options({
  components: {
    SideMenu,
  },
})
export default class TaskDetails extends Vue {
  public allTable: any = [];
  public loading = false;
  public localProject = Number(getLocalProject());
  public async mounted() {
    this.loading = true;
    await dispatchGetUserProfile(store);
    await dispatchGetMyProjects(store);
    await dispatchGetTaskRecordProject(store, {
      task_record_id: Number(this.id),
    });
    const myprojects = readMyProjects(store);
    const record_project = readRecordProject(store);
    const user_profile = readUserProfile(store);
    const now_project = myprojects.filter(
      (item: any) => Number(item.project.id) === Number(record_project)
    );
    if (now_project.length !== 0 || user_profile?.is_super) {
      await dispatchUpdateMyLastProject(store, {
        last_visit_project: Number(record_project),
      });
      await saveLocalProject(String(record_project));
      await saveLocalStorageProject(String(record_project));
      dispatchGetTaskStatus(this.$store, { project: Number(record_project) });
      dispatchGetPerformanceTableFields(store, {
        project: Number(record_project),
      });
      await dispatchGetDeviceSpecs(store, { project: Number(record_project) });
      await dispatchGetSimpleScripts(store, {
        project: Number(record_project),
      });
      await dispatchGetProjectScenes(store, {
        project: Number(record_project),
      });
      await dispatchGetTaskRecord(this.$store, {
        record_id: this.id,
        project: Number(record_project),
      });
      dispatchGetTaskLogs(store, {
        project: this.localProject,
        task_record_id: readTaskRecord(store)?.id || 0,
      });
      await dispatchGetPerformances(store, {
        project: Number(record_project),
        task_record_id: readTaskRecord(store)?.id || "",
        scene_id: "",
        device_id: "",
      });
    } else {
      dispatchGetTaskStatus(this.$store, { project: this.localProject });
      dispatchGetPerformanceTableFields(store, { project: this.localProject });
      await dispatchGetDeviceSpecs(store, { project: this.localProject });
      await dispatchGetSimpleScripts(store, { project: this.localProject });
      await dispatchGetProjectScenes(store, { project: this.localProject });
      await dispatchGetTaskRecord(this.$store, {
        record_id: this.id,
        project: this.localProject,
      });
      dispatchGetTaskLogs(store, {
        project: this.localProject,
        task_record_id: readTaskRecord(store)?.id || 0,
      });
      await dispatchGetPerformances(store, {
        project: this.localProject,
        task_record_id: readTaskRecord(store)?.id || "",
        scene_id: "",
        device_id: "",
      });
    }
    this.timeout(true);
    this.view_timer(true);
    this.setTaskGroupTable;
    this.table_url;
    this.loading = false;
  }

  get id() {
    return this.$route.query.id;
  }

  public get get_logs() {
    let logs = readTaskLogs(store);
    logs.forEach((item: any) => {
      item.time = dateConversion(item.time);
    });
    return logs;
  }

  public get activeName() {
    if (readTaskRecord(this.$store)?.status === 3) {
      return "second";
    }
    return "first";
  }
  public downloading(i, data, name) {
    let element = document.getElementById(i);
    element.setAttribute(
      "href",
      "data:application/json;charset=utf-8," + encodeURIComponent(data)
    );
    element.setAttribute("download", name);
    element.style.display = "none";
    element.click();
  }
  get taskRecord() {
    return readTaskRecord(this.$store);
  }

  public setTaskInfo() {
    if (this.taskRecord) {
      const taskInfo: any = [];
      let item = this.taskRecord;
      const state: any = readTaskStatus(store);
      taskInfo.push({
        id: item.id,
        task_name: item.task_name,
        status: state[item.status],
        start_date: dateConversion(item.start_date),
        end_date: dateConversion(item.end_date),
        task: item.task,
        project: item.project,
        create_user: item.create_user,
      });
      return taskInfo;
    }
  }

  public get getPerformances() {
    return readPerformances(store);
  }

  public get get_version() {
    return (
      this.getPerformances.filter((item) => item.game_version !== "")[0]
        ?.game_version || ""
    );
  }
  public get table_url() {
    let list = this.get_table_data;
    this.setTaskGroupTable.forEach(function (v: any) {
      list.forEach(function (k: any) {
        if (
          k.device_uuid === v.UUID &&
          k.scene_chinese === v.scene &&
          k.script_id === v.script_id &&
          k.task_group_index === v.task_group_index
        ) {
          v.url = k.url;
        }
      });
    });

    return this.setTaskGroupTable;
  }
  // 客户端性能表格
  public get get_table_data() {
    let data: any[] = this.getPerformances;

    data.forEach((item) => {
      item.timestamp = dateConversion(item.timestamp);
      const device = readDeviceSpecs(store).filter(
        (device) => device.id === item.device_id
      )[0];

      item.scene_chinese = readProjectScenes(store).filter(
        (scene: any) => scene.id === item.scene_id
      )[0]?.chinese;
      item.device_name = device?.level + 1 + "档机-" + device?.remark + `-${device?.model?.name}`;
      item.device_uuid = device?.UUID;
    });

    let table_data: any[] = [];

    this.setTaskGroupTable.forEach((task_item: any) => {
      const item = data.filter(
        (item) =>
          item.device_uuid === task_item.UUID &&
          item.scene_chinese === task_item.scene &&
          item.script_id === task_item.script_id &&
          item.task_group_index === task_item.task_group_index
      );

      if (item.length === 0) {
        table_data.push({
          avg_cpu: "-",
          avg_cpu_total: "-",
          avg_dc: "-",
          avg_flow: "-",
          avg_fps: "-",
          continue_low_lag_cnt: "-",
          custom_data: "",
          cpu_lt_60_pcnt: "-",
          cpu_lt_80_pcnt: "-",
          device_id: "-",
          device_name:
            task_item.device_level + 1 + "档机-" + task_item.device_remark,
          dps: "-",
          duration: "-",
          fps_lt_10_pcnt: "-",
          fps_lt_18_pcnt: "-",
          fps_lt_25_pcnt: "-",
          fps_lt_40_pcnt: "-",
          fps_lt_50_pcnt: "-",
          fps_lt_55_pcnt: "-",
          game_version: "-",
          gc_cnt: "-",
          gc_freq: "-",
          id: "-",
          id_frame_end: "-",
          id_frame_start: "-",
          id_label: "-",
          id_row_end: "-",
          id_row_start: "-",
          id_test: "-",
          lag_cnt: "-",
          lag_freq: "-",
          lag_pcnt: "-",
          logic_down_flow: "-",
          logic_up_flow: "-",
          max_dc: "-",
          max_mono_total: "-",
          max_mono_used: "-",
          max_pss: "-",
          max_swap: "-",
          max_swap_add_pss: "-",
          max_triangle: "-",
          max_vss: "-",
          multiple_peak_lag_cnt: "-",
          period: "-",
          process_down_flow: "-",
          process_up_flow: "-",
          project: "-",
          remark: "-",
          runmax_id: "-",
          scene_chinese: task_item.scene,
          scene_id: "-",
          script_id: "-",
          single_peak_lag_cnt: "-",
          task_group_index: "-",
          task_record_id: "-",
          timestamp: "-",
          url: "-",
          max帧耗时: "-",
          卡顿时长: "-",
          卡顿次数: "-",
          卡顿率1: "-",
          卡顿详情: "-",
          帧耗时标准差: "-",
          rowNum: task_item.rowNum,
        });
      } else {
        item[0].rowNum = task_item.rowNum;
        // CFM如果需要添加指标 就往list数组加入即可
        let list = [
          "卡顿时长",
          "卡顿次数",
          "卡顿率1",
          "卡顿详情",
          "帧耗时标准差",
          "max帧耗时",
        ];
        if (this.localProject === 42 || this.localProject === 31) {
          if (item[0].custom_data != null) {
            item[0].new_data = JSON.parse(item[0].custom_data);
            for (let i in item[0].new_data) {
              if (list.indexOf(i) != -1) {
                item[0][i] = item[0].new_data[i];
              }
            }
          } else {
            list.forEach(function (v: any) {
              item[0][v] = "-";
            });
          }
        }

        // project 71 时，FPS>=50/55 的值在 custom_data 中
        if (Number(this.localProject) === 71) {
          if (item[0].custom_data != null) {
            try {
              item[0].new_data = JSON.parse(item[0].custom_data);
            } catch (e) {
              item[0].new_data = {};
            }
            // 兼容 "FPS>=50[%]" 与 "FPS>50[%]" 两种 key 格式
            item[0].fps_lt_50_pcnt =
              item[0].new_data["FPS>=50[%]"] ??
              item[0].new_data["FPS>50[%]"] ??
              "-";
            item[0].fps_lt_55_pcnt =
              item[0].new_data["FPS>=55[%]"] ??
              item[0].new_data["FPS>55[%]"] ??
              "-";
          } else {
            item[0].fps_lt_50_pcnt = "-";
            item[0].fps_lt_55_pcnt = "-";
          }
        }

        table_data.push(item[0]);
      }
    });

    return table_data;
  }

  // 任务基本信息
  get taskRecordTable() {
    return this.setTaskInfo();
  }

  // json结构化后的status_detail
  get taskGroup() {
    try {
      return JSON.parse(this.taskRecord?.status_detail).task_group;
    } catch (e) {
      return null;
    }
  }

  //改版1, 任务组列表
  public get setTaskGroupTable() {
    if (this.taskGroup) {
      let tableData: any = [];
      const task_record_item = this.taskRecord;
      let last_scene: any = 0; // 用于判断是否是第一个场景
      let task_group_index = 0;
      for (let i = 0; i < this.taskGroup.length; i++) {
        const task_item = this.taskGroup[i];
        const item = this.taskGroup[i].device_group;
        const rowNum = Object.keys(item).length;
        let current_index = 0;
        let last_timer = 0; // 用于存储一个场景中所有设备任务接受阶段最大的时间戳，赋值给last_time

        Object.keys(item).forEach(function (key) {
          let scene_status = task_item.status;
          if (task_item.status === 3) {
            if (task_item.rest_cycle_count === 0) {
              scene_status = 3;
            } else {
              scene_status = 1;
            }
          }
          let start_timer = "-- : --";
          let download_timer = "-- : --";
          let login_timer = "-- : --";
          let enter_scene_timer = "-- : --";
          let in_scene_timer = "-- : --";
          let time_difference: any;

          if (item[key].phase.finish.complete_time) {
            if (
              last_timer <
              new Date(item[key].phase.finish.complete_time).getTime()
            ) {
              last_timer = new Date(
                item[key].phase.finish.complete_time
              ).getTime();
            }
          }

          // 任务接受阶段计时器
          if (item[key].phase.start.status === "running") {
            // 运行时，当前时间-上一阶段完成时间, 任务状态为取消时，取任务结束时间-上一阶段完成时间

            if (last_scene !== 0) {
              if (task_record_item?.status === 4) {
                time_difference =
                  new Date(task_record_item?.end_date).getTime() - last_scene;
              } else {
                time_difference = new Date().getTime() - last_scene;
                // new Date(task_record_item?.start_date).getTime();
              }
            } else {
              if (task_record_item?.status === 4) {
                time_difference =
                  new Date(task_record_item?.end_date).getTime() -
                  new Date(task_record_item?.start_date).getTime();
              } else {
                time_difference =
                  new Date().getTime() -
                  new Date(task_record_item?.start_date).getTime();
              }
            }
          } else if (
            item[key].phase.start.status === "done" ||
            item[key].phase.start.status === "error"
          ) {
            // 完成时，当前阶段完成时间-上一阶段完成时间
            if (last_scene !== 0) {
              time_difference =
                new Date(item[key].phase.start.complete_time).getTime() -
                last_scene;
            } else {
              time_difference =
                new Date(item[key].phase.start.complete_time).getTime() -
                new Date(task_record_item?.start_date).getTime();
            }
          } else {
            time_difference = "";
          }

          // 时间差值处理为可读类型
          if (time_difference !== "" && time_difference > 0) {
            let new_time = new Date(time_difference);
            // 它是从1900年开始计时的，所以做处理
            new_time.setTime(time_difference - 1000 * 60 * 60 * 8);
            let day = dateConversion(new_time).slice(8, 10);
            let hour = dateConversion(new_time).slice(11, 13);
            let min = dateConversion(new_time).slice(14);
            if (hour !== "00") {
              start_timer = (Number(day) - 1) * 24 + Number(hour) + ":" + min;
            } else if (min === "00:00") {
              start_timer = "00:01";
            } else {
              start_timer = min;
            }
          } else if (time_difference <= 0) {
            start_timer = "00:01";
          }

          if (
            start_timer === "N:NaN:NaN" ||
            start_timer === " NaN:NaN:NaN" ||
            start_timer.includes("NaN")
          ) {
            start_timer = "00:01";
          }

          // 安装阶段计时器
          if (item[key].phase.download.status === "running") {
            // 运行时，当前时间-上一阶段完成时间
            if (task_record_item?.status === 4) {
              time_difference =
                new Date(task_record_item?.end_date).getTime() -
                new Date(item[key].phase.start.complete_time).getTime();
            } else {
              time_difference =
                new Date().getTime() -
                new Date(item[key].phase.start.complete_time).getTime();
            }
          } else if (
            item[key].phase.download.status === "done" ||
            item[key].phase.download.status === "error"
          ) {
            // 完成时，当前阶段完成时间-上一阶段完成时间
            time_difference =
              new Date(item[key].phase.download.complete_time).getTime() -
              new Date(item[key].phase.start.complete_time).getTime();
          } else {
            time_difference = "";
          }

          // 时间差值处理为可读类型
          if (time_difference !== "" && time_difference > 0) {
            let new_time = new Date(time_difference);
            // 它是从1900年开始计时的，所以做处理
            new_time.setTime(time_difference - 1000 * 60 * 60 * 8);
            let day = dateConversion(new_time).slice(8, 10);
            let hour = dateConversion(new_time).slice(11, 13);
            let min = dateConversion(new_time).slice(14);
            if (hour !== "00") {
              download_timer =
                (Number(day) - 1) * 24 + Number(hour) + ":" + min;
            } else if (min === "00:00") {
              download_timer = "00:01";
            } else {
              download_timer = min;
            }
          } else if (time_difference <= 0) {
            download_timer = "00:01";
          }

          if (
            download_timer === "N:NaN:NaN" ||
            download_timer === " NaN:NaN:NaN" ||
            download_timer.includes("NaN")
          ) {
            download_timer = "00:01";
          }

          // 登录阶段计时器
          if (item[key].phase.login.status === "running") {
            // 运行时，当前时间-上一阶段完成时间
            if (task_record_item?.status === 4) {
              time_difference =
                new Date(task_record_item?.end_date).getTime() -
                new Date(item[key].phase.download.complete_time).getTime();
            } else {
              time_difference =
                new Date().getTime() -
                new Date(item[key].phase.download.complete_time).getTime();
            }
          } else if (
            item[key].phase.login.status === "done" ||
            item[key].phase.login.status === "error"
          ) {
            // 完成, 异常时，当前阶段完成时间-上一阶段完成时间
            time_difference =
              new Date(item[key].phase.login.complete_time).getTime() -
              new Date(item[key].phase.download.complete_time).getTime();
          } else {
            time_difference = "";
          }

          // 时间差值处理为可读类型
          if (time_difference !== "" && time_difference > 0) {
            let new_time = new Date(time_difference);
            // 它是从1900年开始计时的，所以做处理
            new_time.setTime(time_difference - 1000 * 60 * 60 * 8);
            let day = dateConversion(new_time).slice(8, 10);
            let hour = dateConversion(new_time).slice(11, 13);
            let min = dateConversion(new_time).slice(14);
            if (hour !== "00") {
              login_timer = (Number(day) - 1) * 24 + Number(hour) + ":" + min;
            } else if (min === "00:00") {
              login_timer = "00:01";
            } else {
              login_timer = min;
            }
          } else if (time_difference <= 0) {
            login_timer = "00:01";
          }

          if (
            login_timer === "N:NaN:NaN" ||
            login_timer === " NaN:NaN:NaN" ||
            login_timer.includes("NaN")
          ) {
            login_timer = "00:01";
          }

          // 进入场景阶段计时器
          if (item[key].phase.enter_scene.status === "running") {
            // 运行时，当前时间-上一阶段完成时间
            if (task_record_item?.status === 4) {
              time_difference =
                new Date(task_record_item?.end_date).getTime() -
                new Date(item[key].phase.login.complete_time).getTime();
            } else {
              time_difference =
                new Date().getTime() -
                new Date(item[key].phase.login.complete_time).getTime();
            }
          } else if (
            item[key].phase.enter_scene.status === "done" ||
            item[key].phase.enter_scene.status === "error"
          ) {
            // 完成时，当前阶段完成时间-上一阶段完成时间
            time_difference =
              new Date(item[key].phase.enter_scene.complete_time).getTime() -
              new Date(item[key].phase.login.complete_time).getTime();
          } else {
            time_difference = "";
          }

          // 时间差值处理为可读类型
          if (time_difference !== "" && time_difference > 0) {
            let new_time = new Date(time_difference);
            // 它是从1900年开始计时的，所以做处理
            new_time.setTime(time_difference - 1000 * 60 * 60 * 8);
            let day = dateConversion(new_time).slice(8, 10);
            let hour = dateConversion(new_time).slice(11, 13);
            let min = dateConversion(new_time).slice(14);
            if (hour !== "00") {
              enter_scene_timer =
                (Number(day) - 1) * 24 + Number(hour) + ":" + min;
              // enter_scene_timer = dateConversion(new_time).slice(11);
            } else if (min === "00:00") {
              enter_scene_timer = "00:01";
            } else {
              enter_scene_timer = min;
            }
          } else if (time_difference <= 0) {
            enter_scene_timer = "00:01";
          }

          if (
            enter_scene_timer === "N:NaN:NaN" ||
            enter_scene_timer === " NaN:NaN:NaN" ||
            enter_scene_timer.includes("NaN")
          ) {
            enter_scene_timer = "00:01";
          }

          // 场景执行阶段计时器
          if (item[key].phase.in_scene.status === "running") {
            // 运行时，当前时间-上一阶段完成时间
            if (task_record_item?.status === 4) {
              time_difference =
                new Date(task_record_item?.end_date).getTime() -
                new Date(item[key].phase.enter_scene.complete_time).getTime();
            } else {
              time_difference =
                new Date().getTime() -
                new Date(item[key].phase.enter_scene.complete_time).getTime();
            }
          } else if (
            item[key].phase.in_scene.status === "done" ||
            item[key].phase.in_scene.status === "error"
          ) {
            // 完成时，当前阶段完成时间-上一阶段完成时间
            time_difference =
              new Date(item[key].phase.in_scene.complete_time).getTime() -
              new Date(item[key].phase.enter_scene.complete_time).getTime();
          } else {
            time_difference = "";
          }

          // 时间差值处理为可读类型
          if (time_difference !== "" && time_difference > 0) {
            let new_time = new Date(time_difference);
            // 它是从1900年开始计时的，所以做处理
            new_time.setTime(time_difference - 1000 * 60 * 60 * 8);
            let day = dateConversion(new_time).slice(8, 10);
            let hour = dateConversion(new_time).slice(11, 13);
            let min = dateConversion(new_time).slice(14);
            if (hour !== "00") {
              in_scene_timer =
                (Number(day) - 1) * 24 + Number(hour) + ":" + min;
              // in_scene_timer = dateConversion(new_time).slice(11);
            } else if (min === "00:00") {
              in_scene_timer = "00:01";
            } else {
              in_scene_timer = min;
            }
          } else if (time_difference <= 0) {
            in_scene_timer = "00:01";
          }

          if (
            in_scene_timer === "N:NaN:NaN" ||
            in_scene_timer === " NaN:NaN:NaN" ||
            in_scene_timer.includes("NaN")
          ) {
            in_scene_timer = "00:01";
          }

          const data: any = {
            name: task_item.name,
            scene:
              readProjectScenes(store).filter(
                (item: any) => item.id === task_item.scene_id
              )[0]?.chinese || "-",
            cycle_count: task_item.cycle_count,
            rest_cycle_count: task_item.rest_cycle_count,
            status: scene_status,

            device_id:
              readDeviceSpecs(store).filter(
                (item) => String(item.id) === key
              )[0]?.model.model || "-",
            UUID:
              readDeviceSpecs(store).filter(
                (item) => String(item.id) === key
              )[0]?.UUID || "-",
            device_specs_name:
              readDeviceSpecs(store).filter(
                (item) => String(item.id) === key
              )[0]?.model.name || "-",
            device_remark:
              readDeviceSpecs(store).filter(
                (item) => String(item.id) === key
              )[0]?.remark || "-",
            device_level: readDeviceSpecs(store).filter(
              (item) => String(item.id) === key
            )[0]?.level,
            scripts:
              readSimpleScriptList(store).filter(
                (script) => script.script_id === item[key].script
              )[0]?.script_name || "-",
            script_id: item[key].script,
            start: item[key].phase.start.status,
            startMsg: item[key].phase.start.msg || "",
            download: item[key].phase.download.status,
            downloadMsg: item[key].phase.download.msg || "",
            login: item[key].phase.login.status,
            loginMsg: item[key].phase.login.msg || "",
            enterScene: item[key].phase.enter_scene.status,
            enterSceneMsg: item[key].phase.enter_scene.msg || "",
            inScene: item[key].phase.in_scene.status,
            inSceneMsg: item[key].phase.in_scene.msg || "",
            start_time: item[key].phase.start.complete_time || "-",
            start_timer: start_timer,
            download_timer: download_timer,
            login_timer: login_timer,
            enter_scene_timer: enter_scene_timer,
            in_scene_timer: in_scene_timer,
            end_time: item[key].phase.finish.complete_time || "-",
            now: readRefreshControl(store)?.now,
            task_group_index: task_group_index,
          };
          if (current_index === 0) {
            data.rowNum = rowNum;
          }
          tableData.push(data);
          current_index = current_index + 1;
        });
        last_scene = last_timer;
        task_group_index = task_group_index + 1;
      }
      return tableData;
    } else {
      return [];
    }
  }

  // 刷新
  public async refreshTaskRecord() {
    await dispatchGetTaskRecord(this.$store, {
      record_id: this.id,
      project: this.localProject,
    });
    await dispatchGetPerformances(store, {
      project: this.localProject,
      task_record_id: readTaskRecord(store)?.id || "",
      scene_id: "",
      device_id: "",
    });
    // await dispatchGetDeviceSpecs(store);
    // this.setTaskGroupTable;
  }

  // 定时刷新
  public timeout(is_run: boolean): void {
    if (is_run && readTaskRecord(this.$store)?.status === 1) {
      const timer = setTimeout(() => {
        if (this.$router.currentRoute.value.name !== "TaskDetails") {
          this.timeout(false);
        } else {
          this.refreshTaskRecord();
          this.timeout(is_run);
        }
      }, 10000);
    }
  }

  // 计时器
  public view_timer(is_run: boolean): void {
    if (
      is_run &&
      (readTaskRecord(this.$store)?.status === 1 ||
        readTaskRecord(this.$store)?.status === 2 ||
        readTaskRecord(this.$store)?.status === 5)
    ) {
      const viewTimer = setTimeout(() => {
        if (this.$router.currentRoute.value.name !== "TaskDetails") {
          this.view_timer(false);
        } else {
          commitSetRefreshControl(store, new Date());
          this.setTaskGroupTable;
          this.view_timer(is_run);
        }
      }, 1000);
    }
  }

  // 合并单元行
  public taskGroupSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex === 0 || columnIndex === 1) {
      return {
        rowspan: row.rowNum, // 合并行数
        colspan: row.rowNum > 0 ? 1 : 0, // 合并列数
      };
    }
  }

  public performanceSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex === 0) {
      return {
        rowspan: row.rowNum, // 合并行数
        colspan: row.rowNum > 0 ? 1 : 0, // 合并列数
      };
    }
  }

  //详情的路径
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }

  public get performance_table_fields() {
    const beford_fields = [
      { label: "场景名称", prop: "scene_chinese" },
      { label: "设备", prop: "device_name" },
    ];
    const after_fields = [{ label: "耗时", prop: "duration" }];

    const performance_table_fields = readPerformanceTableFields(store);
    let performance_fields = [];
    performance_fields.push(...beford_fields);
    for (var key in performance_table_fields) {
      let label = performance_table_fields[key];
      let prop = key;
      // project 71 时，将 FPS>=18/25 阈值列替换为 FPS>=50/55
      if (Number(this.localProject) === 71) {
        if (prop === "fps_lt_18_pcnt") {
          label = "FPS>=50占有率(%)";
          prop = "fps_lt_50_pcnt";
        } else if (prop === "fps_lt_25_pcnt") {
          label = "FPS>=55占有率(%)";
          prop = "fps_lt_55_pcnt";
        }
      }
      performance_fields.push({
        label: label,
        prop: prop,
      });
    }
    performance_fields.push(...after_fields);
    return performance_fields;
  }
}
